import React from 'react';
import {
  Col,
  Row,
  Container
} from 'reactstrap';
import useIsHiddenInRoute from '../../hooks/useIsHiddenInRoute';
import HideInRoutes from './HideInRoutes';
import Styles from './Footer.module.css';
import FooterLink from './Link';
import Links from './Links';

function Footer({hideLinks}) {
  const useIsHidden = useIsHiddenInRoute();
  const showLinks = hideLinks !== undefined ? !hideLinks : true;

  const links = Links().map((link, index) => {
    return (
      <Col key={index}>
        <FooterLink
          icon={link.icon}
          caption={link.caption}
          href={link.href}
          figureClassName={link.figureClassName}
        />
      </Col>
    )
  });

  let hide = false;

  HideInRoutes().forEach(function(route) {
    if (useIsHidden.isHidden(route)) {
      hide = true;
      return false;
    }
  });

  if (hide) {
    return null;
  }

  return (
    <footer className={Styles.footer + ' position-fixed bottom-0 w-100 h-3 bg-white'}>
      <Container className='mt-3'>
        {
          showLinks &&
          <Row className={Styles.linksContainer + ' font-copper-hewitt-normal'}>
            {links}
          </Row>
        }
        <Row className='d-none'>
          <Col className='text-center'>
            <span className='font-copper-hewitt-normal'>builde.app</span>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
